export default __webpack_public_path__ + "static/media/224.7ad394a4.jpg";